module.exports = __webpack_public_path__ + "catalog/items/office/Table-and-chair/Table-and-chair.svg";